export const STEP_LIST = ['都道府県の確認', '等級検査の確認', '基本情報の登録', '希望オファー入力'] as const
